import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private apiUrl = 'https://apihomolog-v2.codeciphers.com/CCLoginUnico/v2/token';

  constructor(private http: HttpClient) { }

  hasToken() {
    return !!this.getToken();
  }

  setToken(tokenValue: string) {
    localStorage.setItem('token', tokenValue);
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  removeToken() {
    localStorage.removeItem('token');
  }

  fetchToken(): Observable<any> {
    const headers = new HttpHeaders({
      'APP_ID': '86BF9FC6-78AD-4A65-89E8-8C91F8EAC43D',
      'PARAM_LOGIN': '5372',
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const body = new HttpParams()
      .set('grant_type', 'password')
      .set('username', 'giuliannaRibeiro')
      .set('password', 'Giu*252003.')
      .set('tipoLogin', '0');

    return this.http.post<any>(this.apiUrl, body.toString(), { headers }).pipe(
      tap(response => {
        this.setToken(response.access_token);
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Error fetching token:', error);
        return throwError(error);
      })
    );
  }

}
